module.exports = __webpack_public_path__ + "static/media/bg.477ca455.png";